<template>
  <ProjectSellerList :project="project" @input="$emit('input', $event)"/>
</template>

<script>
import ProjectSellerList from '../../../../components/Relations/ProjectSellers/Panels/List'

export default {
  components: {ProjectSellerList},

  model: {
    prop: 'project'
  },

  props: {
    project: {
      required: true,
      type: Object
    }
  }
}
</script>
